import axios from 'axios';
import BaseAPI from './base/base-api';

class VersionFeatureAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'versionfeature';
}

export default new VersionFeatureAPI();